// Smooth scrolling JS
(function($){
  // Add smooth scrolling to all links
  $("a").not('.open-popup-link, .gform_button').on('click', function(event) {


    // Exclude anchors inside parents of open-popup-link 
    let parent = $(this).parent();
    if (parent.hasClass('open-popup-link')) {
      return;
    }

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
    	// Store hash
      var hash = this.hash;

    	//only intercept if the hash is on the page
    	if (!$(hash).length) return;

      // Prevent default anchor click behavior
      event.preventDefault();

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top - 220
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
          if(history.pushState) {
          history.pushState(null, null, hash);
          }
          else {
              location.hash = hash;
          }
      });
    } // End if
  });

  if(window.location.hash && $(window.location.hash).length){
    var $section = $(window.location.hash);

    if ($section.hasClass('standard-modal')) {
      return;
    }

    // smooth scroll to the anchor id
    $('html, body').animate({
      scrollTop: $(window.location.hash).offset().top - 220
    }, 800);
  }

})(jQuery);
